import React, { useState, useEffect } from 'react';
import { Icon } from '@b-design/fusion';
import MiniappTable from '../miniappTable';
import Button from '@/components/Button';
import TableFilter from '@/components/TableFilter';
import PaginationComponent from '@/components/PaginationComponent';
import Requests from '@/services/request';
import $i18n from '@/i18n';
import CalculateComponent from '@/components/CalculateComponent';
import CreateDrawer from '@/components/CreateMiniappDrawer';
import { getQueryStringArgs } from '@/utils/url-parse';
import store from '@/store';

import './index.less';

const filterKeys = [
  {
    key: 'name',
    label: $i18n.get({
      id: 'aopf.pages.miniapp.drawer.form.Miniapp.Name',
      dm: 'Miniapp Name',
    }),
  },
  {
    key: 'appIdList',
    label: $i18n.get({
      id: 'aopf.pages.miniapp.version.info.title.Miniapp.ID',
      dm: 'Miniapp ID',
    }),
  },
];

const Active: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [createTitle, setCreateTitle] = useState('');

  // 分页参数
  const [paginationValue, setPaginationValue] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const [filterValue, setFilterValue] = useState<any>({});
  const [tableData, setTableData] = useState({ totalCount: 0, data: [] }); // 列表数据和总条数
  const [contentHeight, setContentHeight] = useState(296);
  const [loading, setLoading] = useState(false);
  const [initFlag, setInitFlag] = useState(false);
  const [spaceRoleState] = store.useModel('spaceRole');

  const { showDrawer, spaceId } = getQueryStringArgs();

  useEffect(() => {
    if (showDrawer) {
      setVisible(true);
    }
  }, [showDrawer]);

  useEffect(() => {
    initData(paginationValue);
    setInitFlag(false);
  }, []);

  useEffect(() => {
    if (createTitle === 'createMiniapp') {
      initData({ currentPage: 1, pageSize: 10 });
      setCreateTitle('');
      setInitFlag(false);
    }
  }, [createTitle]);

  /**
   * 初始化表单数据请求
   * @param params 分页参数
   */
  const initData = (params) => {
    setLoading(true);
    Requests.get('/rest/intercnn/app/queryWithLatestPublishVersion', { ...params, spaceId, name: encodeURIComponent(params?.name || '') }).then(
      (data) => {
        if (data) {
          const { total = 0, list = [] } = data;
          setTableData({
            totalCount: total,
            data: list,
          });
          setLoading(false);
        }
      },
    );
  };

  /**
   * 条件查询处理
   * @param filterParams 询筛选参数
   */
  const searchHandler = (filterParams) => {
    const payload = {
      currentPage: 1,
      pageSize: 10,
      ...filterParams,
    };

    setFilterValue(filterParams);
    initData(payload);
    setInitFlag(true);
  };

  /**
   * 翻页查询处理
   * @param current 当前页码
   * @param pageSize 每页数据量
   */
  const pageChangeHandler = (current: number, pageSize: number) => {
    const payload = {
      ...filterValue,
      currentPage: current,
      pageSize,
    };

    setPaginationValue({
      currentPage: current,
      pageSize,
    });
    initData(payload);
    setInitFlag(false);
  };
  return (
    <div className="list-content">
      <div className="content-btns-filter">
        {spaceRoleState.roleList?.includes('ADMIN') ? (
          <Button
            type="primary"
            data-child-type="icon-text"
            id="btn-create-miniapp"
            onClick={() => setVisible(true)}
          >
            <Icon type="add--circle--filled" />
            {$i18n.get({ id: 'aopf.pages.miniapp.Creat.miniapp', dm: '创建应用' })}
          </Button>
        ) : null}

        <TableFilter filterKeys={filterKeys} filterHandle={searchHandler} />
      </div>

      <MiniappTable
        style={{ height: contentHeight }}
        dataSource={tableData.data}
        loading={loading}
        initFlag={initFlag}
        setCreateTitle={setCreateTitle}
        spaceId={spaceId || ''}
      />

      <PaginationComponent
        total={tableData.totalCount}
        current={paginationValue.currentPage}
        pageSize={paginationValue.pageSize}
        onPageChange={pageChangeHandler}
      />

      <CalculateComponent
        otherWidth={280}
        otherHeight={108 + 80 + 80}
        windowChange={(_width, height) => {
          setContentHeight(height);
        }}
      />
      <CreateDrawer
        visible={visible}
        setVisible={setVisible}
        setCreateTitle={setCreateTitle}
        status="create"
      />
    </div>
  );
};

export default Active;
